import { useEffect, useState } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { useIsUngated } from 'portals-platform-lib';
import { GATES } from '../constants/gates';
import { usageTracker } from '../utils/usageTracker';
import { InboxNavPanel } from '../components/InboxNavPanel';
import { TicketInfoPanel } from '../components/TicketInfoPanel';
import { TicketThreadViewerWrapper } from '../components/TicketThreadViewerWrapper';
import { LegacyTicketThreadViewerWrapper } from '../components/LegacyTicketThreadViewerWrapper';
import { useIsMobile } from '../hooks/useBreakpoint';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function TicketDetails() {
  const isInboxNavEnabled = useIsUngated(GATES.INBOX_NAVIGATION);
  const isMobile = useIsMobile();

  // combined panel state (gated-on path)
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [isInboxNavOpen, setIsInboxNavOpen] = useState(false);
  // legacy panel state (gated-off path)
  const [isInfoPanelOpen, setIsInfoPanelOpen] = useState(false);
  const [isAttachmentsPanelOpen, setIsAttachmentsPanelOpen] = useState(false);
  useEffect(() => {
    usageTracker.track('Customer Portal App', 'Page Viewed', {
      screen: 'ticket-details'
    });
  }, []);
  if (isInboxNavEnabled) {
    return /*#__PURE__*/_jsxs(Flex, {
      flexGrow: "1",
      blockSize: "100%",
      children: [isMobile ? /*#__PURE__*/_jsx(InboxNavPanel, {
        isMobile: true,
        isInboxNavOpen: isInboxNavOpen,
        setIsInboxNavOpen: setIsInboxNavOpen
      }) : /*#__PURE__*/_jsx(InboxNavPanel, {}), /*#__PURE__*/_jsx(TicketThreadViewerWrapper, {
        isPanelOpen: isPanelOpen,
        setIsPanelOpen: setIsPanelOpen
      })]
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    flexGrow: "1",
    blockSize: "100%",
    children: [/*#__PURE__*/_jsx(TicketInfoPanel, {
      isMobile: isMobile,
      isInfoPanelOpen: isInfoPanelOpen,
      setIsInfoPanelOpen: setIsInfoPanelOpen
    }), /*#__PURE__*/_jsx(LegacyTicketThreadViewerWrapper, {
      setIsInfoPanelOpen: setIsInfoPanelOpen,
      isAttachmentsPanelOpen: isAttachmentsPanelOpen,
      setIsAttachmentsPanelOpen: setIsAttachmentsPanelOpen
    })]
  });
}